/* eslint-disable unicorn/filename-case -- a hook is not a component, and this package's rule assumes one */
import * as React from 'react';

/** Opens a combobox popup once, the instant `ready` flips true, and focuses the field with the given `id`. */
export function useAutoFocusOnFill(id: string, ready: boolean) {
  const [open, setOpen] = React.useState(false);
  // Seeded false, not from `ready`: a field whose auto-focus is derived during the very same
  // render pass can already have `ready === true` the first time this hook runs, and that
  // first-ever `true` still needs to open the popup rather than read as "no change".
  const [wasReady, setWasReady] = React.useState(false);
  if (ready !== wasReady) {
    setWasReady(ready);
    if (ready) setOpen(true);
  }

  React.useEffect(() => {
    if (!ready) return;
    document.getElementById(id)?.focus();
  }, [ready, id]);

  return [open, setOpen] as const;
}
